import StepOne from "@/components/dashboard/buyCrypto/StepOne";

export default function BuyCryptoOne() {
  return <StepOne />;
}
